import { Component, OnInit } from "@angular/core";
import { DataService } from "src/app/data.service";
import { Router } from "@angular/router";
import { ActivatedRoute } from "@angular/router";
import { AppConfig } from "./../../config";
import { ToastService } from "ng-uikit-pro-standard";
import * as _ from "underscore";
import {
  CdkDragDrop,
  moveItemInArray,
  transferArrayItem,
} from "@angular/cdk/drag-drop";
import { GUID } from "src/app/guid";

@Component({
  selector: "app-searchlayoutfields",
  templateUrl: "./searchlayoutfields.component.html",
  styleUrls: ["./searchlayoutfields.component.scss"],
})
export class SearchlayoutfieldsComponent implements OnInit {
  isLoading = false;
  isError = false;
  errorMessage = "";
  metasearchlayout: { fields: any[] };
  metaobjectId: string;
  metaobjectName: string;
  profileName: any;
  profileId: any;
  guid: GUID;
  mode: string;
  metaSearchLayoutId: any;
  fields = [];
  fieldList = [];
  fieldsToDo = [];
  fieldsDone = [];

  drop(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
      console.log(this.fieldsDone);
    } else {
      console.log(this.fieldsDone);

      if (this.fieldsDone.length < 20) {
        transferArrayItem(
          event.previousContainer.data,
          event.container.data,
          event.previousIndex,
          event.currentIndex
        );
      }
    }
  }

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private dataService: DataService,
    private _router: Router,
    private appConfig: AppConfig,
    private toastrService: ToastService
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      // this.mode = this.route.snapshot.params.mode;
      this.metaobjectId = this.route.snapshot.params.objectId;
      this.metaobjectName = this.route.snapshot.params.objectName;
      this.profileId = this.route.snapshot.params.profileid;
      this.profileName = this.route.snapshot.params.profile;
      this.mode = this.route.snapshot.params.mode;
      this.metaSearchLayoutId = this.route.snapshot.params.id;
    });

    this.guid = new GUID();
    console.log(this.mode);
    console.log(this.metaSearchLayoutId);
    this.getAllMetaProfileFieldsByObject();

    if (this.mode === "edit") {
      this.getSearchLayout();
    }
  }

  getSearchLayout() {
    var userDetail = JSON.parse(localStorage.getItem("crm_userdetails"));

    let postOption = {
      organizationid: localStorage.getItem("crm_orgid"),
      userid: localStorage.getItem("crm_userid"),
      username: localStorage.getItem("crm_username"),
      // domain: localStorage.getItem("domain"),
      // subdomain: localStorage.getItem("subdomain"),
      domain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`
      ),
      subdomain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`
      ),
      data: {
        metasearchlayout: {
          metaobjectid: this.metaobjectId,
          // profileid: this.profileId,
          profileid: userDetail.profileid,

          id: this.metaSearchLayoutId,
        },
      },
    };

    console.log(postOption);
    this.isLoading = true;
    this.dataService.getAllSearchLayoutById(postOption).subscribe(
      (res) => {
        // alert('****res****' + JSON.stringify(res));
        console.log(res);
        if (res.success == 1) {
          this.metasearchlayout = res.data.metasearchlayout;
          console.log("Doneeee****", this.metasearchlayout);

          if (this.metasearchlayout != null) {
            this.fieldsDone = this.metasearchlayout.fields;
            console.log(this.metasearchlayout.fields);
          }

          this.isLoading = false;
        } else {
          console.log("No SearchLayout data");
          this.isLoading = false;
          //this.resetDetailFormControls();
        }
      },
      (err) => {
        console.log("Error***:", err);
        this.errorMessage = err.message;
        this.isError = true;
        this.isLoading = false;
        //this.resetDetailFormControls();
      }
    );
  }
  showSuccess(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-top-right",
      timeOut: 3000,
    };
    this.toastrService.success(data, "", options);
  }

  showError(data: any) {
    let options = { enableHtml: true, positionClass: "md-toast-bottom-right" };
    this.toastrService.error(data, "Application Error!", options);
  }

  getAllMetaProfileFieldsByObject() {
    return new Promise((resolve, reject) => {
      console.log("getAllMetaProfileFieldsByObject");

      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        // domain: localStorage.getItem("domain"),
        // subdomain: localStorage.getItem("subdomain"),
        domain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.domain`
        ),
        subdomain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.subdomain`
        ),
        data: {
          metafield: {
            metaobjectid: this.metaobjectId,
          },
        },
      };
      console.log("postOption", postOption);
      this.isLoading = true;
      this.dataService.getAllMetaProfileFieldsByObject(postOption).subscribe(
        (res) => {
          console.log(res);
          if (res !== null && res.success == 1) {
            this.fields = res.data.metaprofilefields;
            this.fieldsToDo = this.fields;

            //create fieldlist from fields as readable form by selection control
            for (let i = 0; i < this.fields.length; i++) {
              var field = this.fields[i];

              //skip id type fields if there
              // if (field.fieldtype.toLowerCase() == "id") continue;

              //skip fields with visibility false
              if (field.visible == false) continue;

              //skip fields deleted, ownertype etc.,
              if (
                (field &&
                  field.metafieldname &&
                  field.metafieldname.toLowerCase() == "deleted") ||
                (field &&
                  field.metafieldname &&
                  field.metafieldname.toLowerCase() == "ownertype") ||
                (field &&
                  field.metafieldname &&
                  field.metafieldname.toLowerCase() == "migrated") ||
                (field &&
                  field.metafieldname &&
                  field.metafieldname.toLowerCase() == "oraganizationid")
              )
                continue;

              //skip converted field if object is lead
              if (
                this.metaobjectName.toLowerCase().trim() == "lead" &&
                field.metafieldname.toLowerCase() == "converted"
              )
                continue;
            }

            this.isLoading = false;
            resolve(null);
          } else {
            console.log("No metaprofilefield data!");
            this.errorMessage =
              res != null ? res.message : "No metaprofilefield data!";
            this.isError = true;
            this.isLoading = false;
            resolve(null);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);
        }
      );
    });
  }

  save() {
    if (this.mode == "new") {
      this.metaSearchLayoutId = this.guid.getGUID("metasearchlayout");
    }

    if (this.fieldsDone != null) {
      var fieldsdisplayed = this.fieldsDone.map((item) => item.metafieldname);
    }
    console.log(fieldsdisplayed);
    let postOption = {
      organizationid: localStorage.getItem("crm_orgid"),
      domain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`
      ),
      subdomain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`
      ),
      userid: localStorage.getItem("crm_userid"),
      username: localStorage.getItem("crm_username"),
      useralias: localStorage.getItem("crm_useralias"),
      data: {
        metasearchlayout: {
          // id: this.guid.getGUID("metasearchlayout"),
          id: this.metaSearchLayoutId,
          mode: this.mode,
          metaobjectid: this.metaobjectId,
          metaobjectname: this.metaobjectName,
          profileid: this.profileId,
          profilename: this.profileName,
          fields: this.fieldsDone,
          fieldsdisplayed: fieldsdisplayed,
          active: true,
        },
      },
    };
    console.log("postOption", postOption);
    this.dataService.upsertMetaSearchlayout(postOption).subscribe(
      (res) => {
        //alert('****res****' + JSON.stringify(res));
        console.log(res);
        if (res.success == 1) {
          this.showSuccess(res.message);
          this.isLoading = false;
          this.router.navigateByUrl("/home/searchlayout");
        } else {
          console.log("error while saving");
          this.showError(res.message);
          this.isLoading = false;
        }
      },
      (err) => {
        console.log("Error***:", err);
        this.showError(err.message);
        this.isError = true;
        this.isLoading = false;
      }
    );
    console.log("URL:", this.appConfig.config.ipaddress);
  }

  cancel() {
    this.router.navigateByUrl(
      "/home/searchlayout/" + this.metaobjectName + "/" + this.metaobjectId
    );
  }
}
